import confetti from 'canvas-confetti';

/** Small burst for correct quiz answers — green/gold particles */
export function fireCorrect() {
  confetti({
    particleCount: 30,
    spread: 60,
    origin: { y: 0.7 },
    colors: ['#22c55e', '#16a34a', '#fbbf24', '#f59e0b'],
    gravity: 1.2,
    scalar: 0.8,
  });
}

/** Big two-burst celebration for quiz pass / course completion */
export function fireCelebration() {
  const defaults = {
    spread: 70,
    ticks: 100,
    gravity: 1,
    decay: 0.94,
    startVelocity: 30,
    colors: ['#22c55e', '#3b82f6', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899'],
  };

  // Left burst
  confetti({
    ...defaults,
    particleCount: 40,
    origin: { x: 0.3, y: 0.7 },
  });

  // Right burst (slightly delayed)
  setTimeout(() => {
    confetti({
      ...defaults,
      particleCount: 40,
      origin: { x: 0.7, y: 0.7 },
    });
  }, 150);
}

/** Fire confetti from a specific DOM element's position */
export function fireFromElement(element: HTMLElement) {
  const rect = element.getBoundingClientRect();
  const x = (rect.left + rect.width / 2) / window.innerWidth;
  const y = (rect.top + rect.height / 2) / window.innerHeight;

  confetti({
    particleCount: 25,
    spread: 50,
    origin: { x, y },
    colors: ['#22c55e', '#16a34a', '#fbbf24'],
    gravity: 1.2,
    scalar: 0.7,
  });
}
